{
  "common": {
    "cancel": "Annuleren",
    "confirm": "Bevestigen",
    "save": "Opslaan",
    "saveChanges": "Wijzigingen opslaan",
    "saved": "Wijzigingen opgeslagen",
    "edit": "Bewerken",
    "copy": "Kopiëren",
    "copied": "Gekopieerd",
    "retry": "Opnieuw proberen",
    "loading": "Laden…",
    "never": "Nooit"
  },
  "time": {
    "justNow": "zojuist"
  },
  "units": {
    "turns": "beurten",
    "messages": "berichten",
    "chars": "tekens",
    "days": "dagen",
    "docs": "docs"
  },
  "status": {
    "active": "Actief",
    "inactive": "Inactief"
  },
  "roles": {
    "owner": "Eigenaar",
    "admin": "Beheerder",
    "member": "Lid",
    "ownerHint": "Volledige controle, inclusief facturering en het verwijderen van de organisatie",
    "adminHint": "Beheert leden, instellingen en alle onderdelen",
    "memberHint": "Gebruikt de portalen waartoe toegang is gegeven"
  },
  "perms": {
    "management": "Studio & beheer",
    "managementHint": "Agents bouwen, tools koppelen en organisatie-instellingen wijzigen.",
    "chat": "Chat",
    "chatHint": "Eén-op-één praten met agents.",
    "workplace": "Werkplaats",
    "workplaceHint": "Samenwerken met agentteams in gedeelde ruimtes.",
    "tasks": "Taken",
    "tasksHint": "Taken en projecten aanmaken, toewijzen en opvolgen."
  },
  "auth": {
    "signOut": "Afmelden",
    "signedOut": "Je bent afgemeld"
  },
  "errors": {
    "network": "De server is niet bereikbaar. Controleer je verbinding en probeer het opnieuw.",
    "rateLimited": "Te veel verzoeken. Wacht even en probeer het opnieuw.",
    "unauthorized": "Je sessie is verlopen. Meld je opnieuw aan.",
    "forbidden": "Je hebt geen toestemming om dit te doen.",
    "server": "Er ging aan onze kant iets mis. Probeer het zo opnieuw.",
    "unknown": "Er gebeurde iets onverwachts.",
    "loadFailed": "Dit kon niet worden geladen",
    "offlineTitle": "Je bent offline",
    "forbiddenTitle": "Geen toegang",
    "notFoundTitle": "Niet gevonden",
    "copyFailed": "Kopiëren naar het klembord is mislukt",
    "pageNotFoundTitle": "Pagina niet gevonden",
    "pageNotFoundDescription": "De pagina die je zoekt bestaat niet of is verplaatst.",
    "backHome": "Terug naar start"
  },
  "validation": {
    "required": "Dit veld is verplicht",
    "minLength_one": "Gebruik minstens {{count}} teken",
    "minLength_other": "Gebruik minstens {{count}} tekens",
    "maxLength_one": "Gebruik hooguit {{count}} teken",
    "maxLength_other": "Gebruik hooguit {{count}} tekens",
    "min": "Moet {{min}} of meer zijn",
    "max": "Moet {{max}} of minder zijn",
    "minItems_one": "Kies minstens {{count}} item",
    "minItems_other": "Kies minstens {{count}} items",
    "email": "Vul een geldig e-mailadres in",
    "url": "Vul een geldige URL in, beginnend met https://",
    "format": "Dit formaat is niet geldig",
    "number": "Vul een getal in"
  },
  "form": {
    "required": "verplicht",
    "none": "Geen",
    "selectPlaceholder": "Kies…",
    "searchPlaceholder": "Zoeken…",
    "noMatches": "Geen resultaten",
    "removeTag": "{{tag}} verwijderen",
    "unsaved": "Je hebt niet-opgeslagen wijzigingen",
    "discard": "Verwerpen",
    "saveChanges": "Wijzigingen opslaan"
  },
  "confirm": {
    "typeToConfirm": {
      "before": "Typ",
      "after": "ter bevestiging."
    },
    "irreversible": "Deze actie kan niet ongedaan worden gemaakt."
  },
  "secret": {
    "title": "Kopieer dit nu — het wordt niet nog eens getoond",
    "description": "Bewaar het op een veilige plek, zoals een wachtwoordmanager of de secret store van je deployment. Kwijt? Maak dan een nieuwe aan.",
    "copy": "Geheim kopiëren",
    "show": "Geheim tonen",
    "hide": "Geheim verbergen"
  },
  "markdown": {
    "image": "Afbeelding",
    "loadImage": "Afbeelding “{{label}}” laden van {{host}}"
  },
  "table": {
    "search": "Zoeken…",
    "clearSearch": "Zoekopdracht wissen",
    "columns": "Kolommen",
    "toggleColumns": "Zichtbare kolommen",
    "actions": "Acties",
    "rowActions": "Rij-acties",
    "empty": "Nog niets hier",
    "noResults": "Geen resultaten",
    "noResultsHint": "Niets komt overeen met “{{query}}”.",
    "showing": "{{from}}–{{to}} van {{total}}",
    "rowsPerPage": "Rijen per pagina",
    "page": "Pagina {{page}} van {{pages}}",
    "previousPage": "Vorige pagina",
    "nextPage": "Volgende pagina"
  },
  "theme": {
    "label": "Thema",
    "light": "Licht",
    "dark": "Donker",
    "system": "Systeem"
  },
  "palette": {
    "label": "Kleurpalet",
    "zacht": "Zacht",
    "meierij": "Meierij wit",
    "leisteen": "Leisteen",
    "salie": "Salie",
    "zand": "Zand",
    "mist": "Mist"
  },
  "language": {
    "label": "Taal"
  },
  "pwa": {
    "install": "App installeren",
    "updateTitle": "Er is een nieuwe versie beschikbaar",
    "updateDescription": "Herlaad om de nieuwste verbeteringen te krijgen.",
    "reload": "Herladen",
    "later": "Later"
  },
  "nav": {
    "main": "Hoofdnavigatie",
    "home": "Start",
    "menu": "Menu",
    "openMenu": "Navigatie openen",
    "breadcrumbs": "Kruimelpad",
    "collapsePanel": "Zijbalk inklappen",
    "expandPanel": "Zijbalk uitklappen",
    "skipToContent": "Naar de inhoud",
    "modes": {
      "chat": "Chat",
      "workplace": "Werkplaats",
      "tasks": "Taken",
      "knowledge": "Kennis",
      "studio": "Studio",
      "insights": "Inzichten",
      "settings": "Instellingen"
    },
    "modeDescriptions": {
      "chat": "Praat met je agents",
      "workplace": "Ruimtes waar agentteams samenwerken",
      "tasks": "Taken, borden en projecten",
      "knowledge": "Documenten en zoeken voor je agents",
      "studio": "Agents bouwen, modellen en tools koppelen",
      "insights": "Runs, kosten en live monitoring",
      "settings": "Organisatie, leden en je account"
    },
    "groups": {
      "build": "Bouwen",
      "models": "Modellen",
      "connect": "Koppelen",
      "automate": "Automatiseren",
      "quality": "Kwaliteit",
      "organization": "Organisatie",
      "account": "Account",
      "platform": "Platform"
    },
    "items": {
      "newChat": "Nieuwe chat",
      "chatHistory": "Geschiedenis",
      "rooms": "Ruimtes",
      "allTasks": "Alle taken",
      "board": "Bord",
      "projects": "Projecten",
      "documents": "Documenten",
      "knowledgeSearch": "Zoeken & indexeren",
      "agents": "Agents",
      "teams": "Teams",
      "skills": "Skills",
      "models": "Modellen",
      "providers": "Providers",
      "mcp": "MCP-servers",
      "connectors": "Connectoren",
      "endpoints": "Endpoints",
      "automations": "Automatiseringen",
      "schedules": "Planningen",
      "evals": "Evaluaties",
      "runs": "Runs",
      "costs": "Kosten",
      "monitor": "Live monitor",
      "general": "Algemeen",
      "members": "Leden",
      "apiTokens": "API-tokens",
      "audit": "Auditlog",
      "profile": "Profiel",
      "organizations": "Organisaties",
      "platformUsers": "Platformgebruikers"
    }
  },
  "command": {
    "title": "Opdrachtenpalet",
    "description": "Zoek pagina's en acties",
    "placeholder": "Typ een opdracht of zoek…",
    "empty": "Geen resultaten gevonden.",
    "open": "Opdrachtenpalet openen",
    "trigger": "Zoek of ga naar…",
    "switchTo": "Wissel naar {{name}}",
    "togglePanel": "Zijbalk tonen/verbergen",
    "theme": "Thema: {{theme}}",
    "palette": "Kleurpalet: {{palette}}",
    "language": "Taal: {{language}}",
    "groups": {
      "organizations": "Organisaties",
      "actions": "Acties",
      "preferences": "Voorkeuren"
    },
    "footer": {
      "navigate": "Navigeren",
      "open": "Openen",
      "close": "Sluiten"
    }
  },
  "shortcuts": {
    "title": "Sneltoetsen",
    "description": "Navigeer zonder je muis aan te raken.",
    "general": "Algemeen",
    "navigation": "Navigatie",
    "palette": "Opdrachtenpalet openen",
    "togglePanel": "Zijbalk tonen/verbergen",
    "help": "Dit overzicht tonen",
    "goTo": "Ga naar {{place}}"
  },
  "userMenu": {
    "label": "Accountmenu",
    "profile": "Profiel",
    "sessions": "Aangemelde apparaten",
    "platformAdmin": "Platformbeheer"
  },
  "login": {
    "title": "Aanmelden",
    "heading": "Welkom terug",
    "subheading": "Meld je aan bij je werkruimte om verder te gaan.",
    "username": "Gebruikersnaam of e-mail",
    "usernamePlaceholder": "jij@bedrijf.nl",
    "password": "Wachtwoord",
    "showPassword": "Wachtwoord tonen",
    "hidePassword": "Wachtwoord verbergen",
    "submit": "Aanmelden",
    "signingIn": "Bezig met aanmelden…",
    "retryIn": "Opnieuw over {{seconds}}s",
    "expired": "Je sessie is beëindigd. Meld je opnieuw aan om verder te gaan waar je was.",
    "help": "Wachtwoord vergeten? Vraag een beheerder van je organisatie om het te resetten.",
    "hintFocus": "gebruikersnaam",
    "hintSubmit": "aanmelden",
    "errors": {
      "failedTitle": "Aanmelden mislukt",
      "failed": "We konden je niet aanmelden. Probeer het opnieuw.",
      "invalidTitle": "Onjuiste gebruikersnaam of wachtwoord",
      "invalid": "Controleer je gegevens en probeer het opnieuw. Gebruikersnamen zijn niet hoofdlettergevoelig.",
      "rateLimitedTitle": "Te veel pogingen",
      "rateLimited": "Voor je veiligheid is aanmelden even gepauzeerd.",
      "rateLimitedWait": "Voor je veiligheid is aanmelden gepauzeerd. Probeer het over {{seconds}} seconden opnieuw.",
      "networkTitle": "Server niet bereikbaar",
      "network": "Controleer je verbinding, of vraag je beheerder of het platform draait.",
      "forbiddenTitle": "Toegang geweigerd",
      "forbidden": "Je account kan zich op dit moment niet aanmelden."
    },
    "brand": {
      "headline": "Agents die samenwerken, op jouw voorwaarden.",
      "subline": "Bouw, draai en orkestreer AI-agents en agentteams op infrastructuur die jij beheert.",
      "pillars": {
        "secure": "Veilig",
        "private": "Privé",
        "open": "Modelonafhankelijk"
      }
    },
    "flow": {
      "title": "incident-review · teamrun",
      "live": "live",
      "agents": {
        "planner": "Planner",
        "researcher": "Onderzoeker",
        "analyst": "Analist",
        "writer": "Schrijver"
      },
      "planner": "verdeelde het verzoek in drie stappen en wees eigenaren aan.",
      "researcher": "verzamelde 14 logfragmenten en 2 gerelateerde incidenten.",
      "analyst": "herleidde de oorzaak tot een configuratiewijziging om 09:42.",
      "writer": "schreef de samenvatting met tijdlijn en vervolgacties.",
      "done": "Flow voltooid — klaar voor jouw review."
    }
  },
  "profile": {
    "title": "Profiel",
    "description": "Je persoonlijke gegevens, voorkeuren, wachtwoord en aangemelde apparaten.",
    "saved": "Profiel bijgewerkt",
    "platformAdmin": "Platformbeheerder",
    "details": {
      "title": "Persoonlijke gegevens",
      "description": "Hoe anderen je zien op dit platform.",
      "displayName": "Weergavenaam",
      "email": "E-mail",
      "emailPlaceholder": "jij@bedrijf.nl",
      "username": "Gebruikersnaam",
      "memberSince": "Lid sinds",
      "lastLogin": "Laatst aangemeld"
    },
    "preferences": {
      "title": "Voorkeuren",
      "description": "Direct toegepast op dit apparaat. Je taal volgt je overal.",
      "themeHint": "Volg je systeem of kies een vaste weergave.",
      "languageHint": "Gebruikt voor de interface en opgeslagen in je profiel."
    },
    "password": {
      "title": "Wachtwoord",
      "description": "Gebruik een lang, uniek wachtwoord. Wijzigen meldt je andere apparaten af.",
      "current": "Huidig wachtwoord",
      "new": "Nieuw wachtwoord",
      "confirm": "Bevestig nieuw wachtwoord",
      "rules": "Minstens 10 tekens, niet alleen cijfers.",
      "mismatch": "De wachtwoorden komen niet overeen",
      "notNumeric": "Mag niet alleen uit cijfers bestaan",
      "submit": "Wachtwoord bijwerken",
      "changed": "Wachtwoord bijgewerkt. Andere apparaten zijn afgemeld.",
      "signsOutOthers": "Je blijft hier aangemeld; alle andere sessies worden beëindigd."
    },
    "sessions": {
      "title": "Aangemelde apparaten",
      "description": "Apparaten die op dit moment bij je account zijn aangemeld.",
      "current": "Dit apparaat",
      "device": "{{browser}} op {{os}}",
      "unknownIp": "Onbekende locatie",
      "lastActive": "Actief",
      "signedIn": "Aangemeld",
      "revoke": "Andere apparaten afmelden",
      "revokeTitle": "Alle andere apparaten afmelden?",
      "revokeDescription_one": "{{count}} ander apparaat wordt direct afgemeld.",
      "revokeDescription_other": "{{count}} andere apparaten worden direct afgemeld.",
      "revoked": "Andere apparaten zijn afgemeld"
    }
  },
  "tenants": {
    "title": "Organisaties",
    "description": "Alle organisaties waar je lid van bent. Elk browsertabblad kan in een andere werken.",
    "search": "Organisaties zoeken…",
    "current": "Huidig",
    "deactivated": "Gedeactiveerd",
    "platformAccess": "Platformtoegang",
    "switchTo": "Naar deze organisatie wisselen",
    "switched": "Gewisseld naar {{name}}",
    "created": "{{name}} aangemaakt",
    "archived": "{{name}} is gedeactiveerd",
    "reactivated": "{{name}} is weer actief",
    "deleted": "{{name}} is verwijderd",
    "columns": {
      "name": "Organisatie",
      "kind": "Type",
      "role": "Jouw rol",
      "members": "Leden",
      "status": "Status",
      "created": "Aangemaakt"
    },
    "kind": {
      "organization": "Organisatie",
      "organizationHint": "Gedeelde werkruimte voor een team of bedrijf",
      "personal": "Persoonlijk",
      "personalHint": "Een privé-zandbak alleen voor jou"
    },
    "form": {
      "name": "Naam",
      "namePlaceholder": "Acme BV",
      "slug": "Slug",
      "slugHint": "Optioneel. Kleine letters, cijfers en streepjes; wordt uit de naam gemaakt als je dit leeg laat.",
      "slugEditHint": "Gebruikt in URL's en API-aanroepen. Wijzigen kan bestaande koppelingen breken.",
      "slugInvalid": "Gebruik alleen kleine letters, cijfers en streepjes",
      "kind": "Type"
    },
    "create": {
      "title": "Nieuwe organisatie",
      "description": "Organisaties houden agents, data en leden gescheiden. Jij wordt de eigenaar.",
      "submit": "Organisatie aanmaken"
    },
    "switcher": {
      "label": "Organisatie wisselen",
      "heading": "Organisaties",
      "none": "Geen organisatie",
      "deactivated": "Gedeactiveerd",
      "settings": "Organisatie-instellingen",
      "all": "Alle organisaties",
      "create": "Nieuwe organisatie"
    },
    "archive": {
      "title": "{{name}} deactiveren?",
      "description": "Leden kunnen deze organisatie niet meer openen en automatiseringen stoppen. Er wordt niets verwijderd; je kunt hem altijd weer activeren.",
      "confirm": "Deactiveren"
    },
    "reactivate": {
      "title": "{{name}} weer activeren?",
      "description": "Leden krijgen weer toegang en automatiseringen gaan verder.",
      "confirm": "Activeren"
    },
    "delete": {
      "title": "{{name}} definitief verwijderen?",
      "description": "Hiermee verdwijnen de organisatie en alles daarin voor alle leden.",
      "confirm": "Organisatie verwijderen",
      "willDelete": "Het volgende wordt definitief verwijderd",
      "nothing": "Deze organisatie heeft geen gegevens naast de instellingen."
    },
    "entities": {
      "agent_runs": "Agentruns",
      "agents": "Agents",
      "chat_sessions": "Chatsessies",
      "connectors": "Connectoren",
      "eval_suites": "Evaluatiesuites",
      "kb_documents": "Documenten",
      "mcp_servers": "MCP-servers",
      "memberships": "Leden",
      "model_providers": "Modelproviders",
      "models": "Modellen",
      "projects": "Projecten",
      "rooms": "Ruimtes",
      "schedules": "Planningen",
      "skills": "Skills",
      "tasks": "Taken",
      "teams": "Teams"
    },
    "empty": {
      "title": "Nog geen organisaties",
      "description": "Maak een organisatie aan om samen met je team agents te bouwen."
    }
  },
  "orgSettings": {
    "title": "Organisatie",
    "description": "Instellingen die gelden voor iedereen in {{name}}.",
    "saved": "Organisatie-instellingen opgeslagen",
    "onThisPage": "Op deze pagina",
    "readOnly": "Alleen eigenaren en beheerders kunnen deze gegevens wijzigen.",
    "defaultSlug": "De slug van de standaardorganisatie kan niet worden gewijzigd.",
    "notSet": "Niet ingesteld",
    "auto": "Automatisch",
    "modelPickerHint": "Modellen beheer je in Studio → Modellen.",
    "providerPickerHint": "Providers beheer je in Studio → Providers.",
    "agentPickerHint": "Agents beheer je in Studio → Agents.",
    "lastUpdated": "Laatst bijgewerkt",
    "sections": {
      "general": {
        "title": "Algemeen",
        "description": "Naam, adres en type van deze organisatie."
      },
      "conversation": {
        "title": "Gesprekken & geheugen",
        "description": "Hoeveel geschiedenis agents bewaren en wanneer lange gesprekken worden samengevat."
      },
      "knowledge": {
        "title": "Kennis & embeddings",
        "description": "Hoe documenten worden omgezet in doorzoekbare vectoren."
      },
      "files": {
        "title": "Bestanden & uploads",
        "description": "Groottelimieten, quota en toegestane bestandstypen."
      },
      "externalChat": {
        "title": "Externe chat-API",
        "description": "Laat andere systemen via het publieke chat-endpoint met een agent praten."
      },
      "evals": {
        "title": "Evaluaties & monitoring",
        "description": "Modellen en drempels om de kwaliteit van agents te beoordelen."
      },
      "observability": {
        "title": "Observability",
        "description": "Links naar de tracing- en fouttools die je team gebruikt."
      },
      "danger": {
        "title": "Gevarenzone",
        "description": "Onomkeerbare en destructieve acties."
      }
    },
    "files": {
      "chatAndProjects": "Chat & projecten",
      "connectors": "Connectoren"
    },
    "fields": {
      "timezone": "Tijdzone",
      "timezoneHint": "Gebruikt voor planningen, rapporten en datums die agents zien.",
      "summaryModel": "Samenvattingsmodel",
      "summaryTriggerTurns": "Samenvatten na elke",
      "summaryTriggerTurnsHint": "Oudere beurten worden samengevoegd in een doorlopende samenvatting.",
      "historyMaxMessages": "Berichten in geschiedenis",
      "historyRecentTurnsFull": "Recente beurten letterlijk bewaard",
      "historyRecentTurnsFullHint": "De nieuwste beurten worden nooit samengevat.",
      "maxToolResponseChars": "Max. bewaarde tooluitvoer",
      "sessionFactsMaxChars": "Budget sessiefeiten",
      "sessionFactsUpdate": "Sessiefeiten bijwerken bij samenvatten",
      "sessionFactsUpdateHint": "Houdt een korte lijst met kernfeiten over het gesprek actueel.",
      "embeddingProvider": "Embeddingprovider",
      "embeddingModel": "Embeddingmodel",
      "embeddingDimensions": "Dimensies",
      "embeddingDimensionsHint": "Laat leeg voor de standaard van het model.",
      "embeddingBatchSize": "Batchgrootte",
      "chatUploadMax": "Uploadlimiet chat",
      "projectFileMax": "Bestandslimiet project",
      "projectQuota": "Opslagquotum project",
      "projectExtensions": "Toegestane projectbestandstypen",
      "connectorFileMax": "Bestandslimiet connector",
      "connectorQuota": "Opslagquotum connector",
      "connectorRetention": "Connectorbestanden bewaren",
      "connectorRetentionHint": "0 bewaart bestanden voor altijd.",
      "connectorExtensions": "Toegestane connectorbestandstypen",
      "extensionsHint": "Druk na elke extensie op Enter of een komma.",
      "externalChatEnabled": "Extern chat-endpoint inschakelen",
      "externalChatEnabledHint": "Verzoeken moeten een API-token met de chat-scope gebruiken.",
      "externalChatAgent": "Agent die externe chats beantwoordt",
      "evalJudgeModel": "Jurymodel",
      "monitorModel": "Model live monitor",
      "evalParallelism": "Parallelle evaluatiecases",
      "evalParallelismHint": "Hoger is sneller maar gebruikt meer providercapaciteit.",
      "evalRegressionThreshold": "Drempel regressiemelding",
      "evalRegressionThresholdHint": "Melden als de score van een suite meer dan dit daalt.",
      "observabilityUrl": "URL tracingdashboard",
      "observabilityUrlHint": "Getoond als link bij runs, bijvoorbeeld je Logfire-project.",
      "sentrySlug": "Sentry-organisatie"
    },
    "danger": {
      "archiveTitle": "Organisatie deactiveren",
      "archiveDescription": "Tijdelijk toegang blokkeren en automatiseringen pauzeren. Dit kun je terugdraaien.",
      "archive": "Deactiveren",
      "deleteTitle": "Organisatie verwijderen",
      "deleteDescription": "Deze organisatie met al haar agents, gesprekken en bestanden definitief verwijderen.",
      "delete": "Verwijderen…",
      "defaultProtected": "De standaardorganisatie is beschermd en kan niet worden gedeactiveerd of verwijderd."
    }
  },
  "members": {
    "title": "Leden",
    "description": "Mensen met toegang tot {{name}} en wat ze kunnen gebruiken.",
    "invite": "Lid uitnodigen",
    "search": "Leden zoeken…",
    "allRoles": "Alle rollen",
    "you": "(jij)",
    "noAccess": "Geen portalen",
    "platformAdmin": "Platformbeheerder",
    "added": "{{name}} is toegevoegd",
    "updated": "{{name}} is bijgewerkt",
    "removed": "{{name}} is verwijderd",
    "remove": "Uit organisatie verwijderen",
    "activate": "Activeren",
    "deactivate": "Deactiveren",
    "columns": {
      "member": "Lid",
      "user": "Gebruiker",
      "role": "Rol",
      "access": "Toegang",
      "status": "Status",
      "lastActive": "Laatst actief"
    },
    "removeConfirm": {
      "title": "{{name}} verwijderen?",
      "description": "Diegene verliest direct de toegang tot deze organisatie. Het account blijft op het platform bestaan."
    },
    "create": {
      "description": "Voeg een bestaande gebruiker toe via de gebruikersnaam, of maak een nieuw account door ook een wachtwoord in te stellen.",
      "submit": "Lid toevoegen"
    },
    "edit": {
      "title": "{{name}} bewerken",
      "description": "Wijzig rol, toegang en accountstatus."
    },
    "empty": {
      "title": "Alleen jij tot nu toe",
      "description": "Nodig collega's uit om samen agents te bouwen en te gebruiken."
    },
    "form": {
      "username": "Gebruikersnaam",
      "usernameHint": "Bestaat deze gebruiker al, dan wordt die aan deze organisatie toegevoegd.",
      "usernameInvalid": "Gebruik alleen letters, cijfers en . _ @ + -",
      "displayName": "Weergavenaam",
      "email": "E-mail",
      "password": "Wachtwoord",
      "passwordHint": "Alleen nodig bij een nieuw account. Minstens 10 tekens.",
      "resetPassword": "Wachtwoord resetten",
      "resetPasswordHint": "Laat leeg om het huidige wachtwoord te behouden.",
      "accessHeading": "Toegang",
      "role": "Rol",
      "selfRoleHint": "Je kunt je eigen rol niet wijzigen.",
      "portals": "Portalen",
      "allAgents": "Alle chatagents",
      "allAgentsHint": "Kan chatten met elke agent die chat toestaat.",
      "allowedAgents": "Toegestane agent-ID's",
      "allowedAgentsHint": "Een visuele agentkiezer komt met Studio → Agents.",
      "allowedAgentsPlaceholder": "bijv. 12, 15",
      "accountHeading": "Account",
      "active": "Actief",
      "activeHint": "Inactieve leden kunnen zich niet aanmelden bij deze organisatie.",
      "platformAdmin": "Platformbeheerder",
      "platformAdminHint": "Volledige toegang tot alle organisaties en platforminstellingen."
    }
  },
  "apiTokens": {
    "title": "API-tokens",
    "description": "Met tokens kunnen scripts, CI en andere systemen namens deze organisatie de API aanroepen.",
    "create": "Token aanmaken",
    "createDescription": "Geef het token een herkenbare naam en alleen de scopes die het nodig heeft.",
    "created": "Token aangemaakt",
    "createdTitle": "“{{name}}” is klaar",
    "createdDescription": "Gebruik het als Bearer-token in de Authorization-header.",
    "done": "Ik heb het token gekopieerd",
    "revoke": "Intrekken",
    "revoked": "“{{name}}” is ingetrokken",
    "service": "Service",
    "neverUsed": "Nooit gebruikt",
    "expired": "Verlopen",
    "noExpiry": "Verloopt niet",
    "usage": "Stuur het token mee in de Authorization-header:",
    "revokeConfirm": {
      "title": "“{{name}}” intrekken?",
      "description": "Alles wat dit token gebruikt, werkt direct niet meer."
    },
    "columns": {
      "name": "Naam",
      "scopes": "Scopes",
      "owner": "Eigenaar",
      "lastUsed": "Laatst gebruikt",
      "expires": "Verloopt",
      "created": "Aangemaakt"
    },
    "empty": {
      "title": "Geen API-tokens",
      "description": "Maak een token aan om de API vanuit scripts of andere systemen aan te roepen."
    },
    "form": {
      "name": "Naam",
      "namePlaceholder": "bijv. Nachtelijke rapportagejob",
      "scopes": "Scopes",
      "scopesRequired": "Kies minstens één scope",
      "expiry": "Verloopt na",
      "days_one": "{{count}} dag",
      "days_other": "{{count}} dagen",
      "never": "Nooit",
      "service": "Servicetoken",
      "serviceHint": "Niet aan jouw account gekoppeld; blijft werken als je vertrekt.",
      "submit": "Token aanmaken"
    },
    "scopes": {
      "management": {
        "label": "Beheer",
        "description": "Agents, modellen, tools en instellingen."
      },
      "chat": {
        "label": "Chat",
        "description": "Berichten naar agents sturen."
      },
      "workplace": {
        "label": "Werkplaats",
        "description": "Ruimtes en agentteams."
      },
      "tasks": {
        "label": "Taken",
        "description": "Taken en projecten aanmaken en bijwerken."
      },
      "kbSearch": {
        "label": "Kennis doorzoeken",
        "description": "Alleen de kennisbank doorzoeken."
      },
      "all": {
        "label": "Volledige toegang",
        "description": "Alles wat deze organisatie toestaat. Spaarzaam gebruiken.",
        "short": "volledige toegang"
      }
    },
    "mcp": {
      "title": "MCP-toegang voor Claude",
      "description": "Beheer dit platform vanuit Claude (Code of Desktop): richt organisaties in (leden, providers, modellen, agents, integraties, kennisbank, chat-endpoints, evals), bekijk runs en projecten en pas prompts of parameters direct aan. Elke wijziging loopt via de normale API, wordt gelogd en maakt agentrevisies aan.",
      "create": "MCP-token aanmaken",
      "endpoint": "Adres:",
      "tokenName": "Claude MCP-toegang",
      "dialogDescription": "Een persoonlijk token voor het /mcp-endpoint.",
      "points": {
        "actsAsYou": "Alleen voor platformbeheerders. Werkt als jou, in elke organisatie (kies er een per tool-aanroep).",
        "onlyMcp": "Werkt alleen op /mcp; de REST API weigert het.",
        "audited": "Wijzigingen worden op jouw naam gelogd; trek het hier op elk moment in."
      },
      "createdTitle": "Je MCP-token",
      "createdDescription": "Kopieer het token nu — het wordt maar één keer getoond. Voeg de server daarna aan Claude toe met een van de fragmenten hieronder.",
      "snippets": {
        "claudeCode": "Claude Code — eenmalig uitvoeren",
        "mcpJson": "Claude Code — .mcp.json (project) of ~/.claude.json",
        "desktop": "Claude Desktop — claude_desktop_config.json (vereist Node.js)"
      }
    }
  },
  "audit": {
    "title": "Auditlog",
    "description": "Wie wat heeft gewijzigd, en wanneer. Geheimen worden altijd gemaskeerd.",
    "search": "Zoek op personen, objecten of wijzigingen…",
    "allEntities": "Alle objecten",
    "allActions": "Alle acties",
    "allOrganizations": "Alle organisaties",
    "clearFilters": "Filters wissen",
    "from": "Vanaf datum",
    "to": "Tot datum",
    "entry": "Auditregel",
    "entryId": "Regel",
    "entityId": "Object-ID",
    "ip": "IP-adres",
    "changes": "Wijzigingen",
    "noChanges": "Voor deze gebeurtenis zijn geen veldwijzigingen vastgelegd.",
    "fieldsChanged_one": "{{count}} veld",
    "fieldsChanged_other": "{{count}} velden",
    "columns": {
      "time": "Wanneer",
      "actor": "Wie",
      "action": "Actie",
      "entity": "Object",
      "changes": "Wijzigingen"
    },
    "diff": {
      "field": "Veld",
      "before": "Voor",
      "after": "Na"
    },
    "actions": {
      "create": "Aangemaakt",
      "update": "Gewijzigd",
      "delete": "Verwijderd",
      "access": "Geopend",
      "login": "Aangemeld",
      "logout": "Afgemeld",
      "execute": "Uitgevoerd"
    },
    "entities": {
      "tenant": "Organisatie",
      "membership": "Lid",
      "user": "Gebruiker",
      "settings": "Instellingen",
      "api_token": "API-token",
      "agent": "Agent",
      "model": "Model",
      "model_provider": "Provider",
      "mcp_server": "MCP-server",
      "skill": "Skill"
    },
    "empty": {
      "title": "Nog geen activiteit",
      "description": "Wijzigingen aan instellingen, leden en onderdelen verschijnen hier."
    },
    "emptyFiltered": {
      "title": "Geen overeenkomende gebeurtenissen",
      "description": "Probeer een andere zoekopdracht of een ruimere periode."
    }
  },
  "platformUsers": {
    "title": "Platformgebruikers",
    "description": "Elk account op dit platform, over alle organisaties heen.",
    "search": "Gebruikers zoeken…",
    "create": "Gebruiker aanmaken",
    "createDescription": "Maak een account aan. Voeg het via de Leden-pagina toe aan organisaties.",
    "edit": "{{name}} bewerken",
    "editDescription": "Werk accountgegevens bij, reset het wachtwoord of wijzig platformtoegang.",
    "created": "{{name}} is aangemaakt",
    "updated": "{{name}} is bijgewerkt",
    "user": "Gebruiker",
    "grantAdmin": "Platformbeheerder maken",
    "revokeAdmin": "Platformbeheer intrekken",
    "passwordRequired": "Voor nieuwe accounts is een wachtwoord verplicht",
    "activeHint": "Inactieve gebruikers kunnen zich nergens aanmelden.",
    "selfHint": "Dit kun je voor je eigen account niet wijzigen.",
    "empty": "Geen gebruikers",
    "columns": {
      "user": "Gebruiker",
      "role": "Platformrol",
      "status": "Status",
      "organizations": "Orgs",
      "lastLogin": "Laatst aangemeld",
      "created": "Aangemaakt"
    },
    "stats": {
      "total": "Gebruikers",
      "active": "Actief",
      "admins": "Platformbeheerders"
    }
  }
}
